import { action } from 'mobx';
import { api } from 'shared/api/api';
import { EntityStore } from 'shared/stores/EntityStore';

class ClientContactStore extends EntityStore {
	constructor() {
		super('client_contacts');
	}

	@action
	async getClientContacts({ text, clientId }) {
		const url = this.entityPluralEndpoint + '/query';
		const queryParams = {
			text,
			pagination: {
				page: 1,
				limit: null
			}
		};

		if (clientId) {
			queryParams.clientId = clientId;
		}

		const result = await api.post(url, {
			query: queryParams
		});

		return result;
	}
}

export const clientContactStore = new ClientContactStore();
